var PostcodeValidator = (function () {
    function PostcodeValidator(invalidPostcodeMessage) {
        this.invalidPostcodeMessage = invalidPostcodeMessage;
    }
    PostcodeValidator.prototype.validatePostcode = function (postcode) {
        if (!postcode ||
            !/^[A-Z]{1,2}[0-9]{1,2}[A-Z]? ?[0-9][ABDEFGHJLNPQRSTUWXYZ]{2}$/i.test(postcode)) {
            return this.invalidPostcodeMessage;
        }
    };
    return PostcodeValidator;
}());
export default PostcodeValidator;
//# sourceMappingURL=postcodeValidator.js.map